var map = {
	"./assets/images/children/timg.png": 1236,
	"./assets/logo.png": 1237,
	"./assets/logo2.png": 1238,
	"./assets/theme-default/images/1.png": 1239,
	"./assets/theme-default/images/admin.png": 1240,
	"./assets/theme-default/images/admin1.png": 1241,
	"./assets/theme-default/images/logo2.png": 1242,
	"./assets/theme-default/images/yxlogo.png": 1243,
	"./assets/theme-default/images/zftlogo.png": 1244
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1320;


//////////////////
// WEBPACK FOOTER
// ./src ^.*\.png$
// module id = 1320
// module chunks = 1